import { GROOMING_SERVICES } from './constants'

export const getAllowedGroomingServicesForPet = (grooming_level) => {

	return [GROOMING_SERVICES.cleanup, GROOMING_SERVICES.trim, GROOMING_SERVICES.haircut]

}
